export const WORDS = [
  'treat',
  'whine',
  'puppy',
  'snout',
  'feral',
  'jindo',
  'chomp',
  'pluto',
  'water',
  'jowls',
  'parks',
  'young',
  'spays',
  'poops',
  'fluff',
  'howls',
  'tabby',
  'dogma',
  'stick',
  'buddy',
  'walks',
  'smell',
  'mouse',
  'packs',
  'spits',
  'catch',
  'scale',
  'train',
  'leash',
  'snarl',
  'grass',
  'chews',
  'beach',
  'bunny',
  'polly',
  'sweet',
  'furry',
  'mutts',
  'trick',
  'silky',
  'coats',
  'snake',
  'tramp',
  'husky',
  'loyal',
  'crate',
  'meows',
  'hairy',
  'chewy',
  'bites',
  'boxer',
  'baths',
  'doggo',
  'smart',
  'whelp',
  'fangs',
  'jumps',
  'hooch',
  'fleas',
  'night',
  'scamp',
  'tough',
  'point',
  'dingo',
  'claws',
  'speed',
  'tails',
  'plays',
  'teach',
  'kitty',
  'chase',
  'scent',
  'bella',
  'bathe',
  'rolls',
  'drink',
  'dance',
  'teeth',
  'scoop',
  'cries',
  'pooch',
  'saint',
  'hound',
  'belly',
  'corgi',
  'sleep',
  'licks',
  'fetch',
  'boops',
  'short',
  'herds',
  'ticks',
  'louse',
  'house',
  'track',
  'shows',
  'noses',
  'snack',
  'purrs',
  'humps',
  'adopt',
  'spots',
  'fence',
  'curly',
  'spoil',
  'breed',
  'bones',
  'cheek',
  'curls',
  'woofs',
  'hunts',
  'bound',
  'alpha',
  'board',
  'blend',
  'shake',
  'knead',
  'place',
  'horse',
  'sniff',
  'beans',
  'mixes',
  'speak',
  'heart',
  'trail',
  'barks',
  'doggy',
];
